import { render, staticRenderFns } from "./Shapes.vue?vue&type=template&id=534e0e28"
import script from "./Shapes.vue?vue&type=script&lang=js"
export * from "./Shapes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports